import { render, staticRenderFns } from "./PriceEdition.vue?vue&type=template&id=695c2d80&"
import script from "./PriceEdition.vue?vue&type=script&lang=js&"
export * from "./PriceEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports